import { QueryClient } from '@tanstack/react-query';
import { builtEnvironment, getIntegrationsUrl, isRunningLocal } from '@shared';
import { ApiClient } from './apiClient';
import getBaseUrl from '@shared/baseUrl';

// Waterlily API client
const waterlilyBaseURL = (() => {
  const origin = getBaseUrl();
  const env = isRunningLocal() ? 'dev' : builtEnvironment;
  return `${origin}/${env}/api`;
})();

export const WaterlilyClient = new ApiClient({
  baseURL: waterlilyBaseURL,
  onUnauthorized: () => {
    WaterlilyClient.clearToken();
  },
});

export const IntegrationsClient = new ApiClient({
  baseURL: getIntegrationsUrl(),
});

// Token management for both clients
export function setAuthToken(token: string): void {
  WaterlilyClient.setToken(token);
  IntegrationsClient.setToken(token);
}

export function clearAuthToken(): void {
  WaterlilyClient.clearToken();
  IntegrationsClient.clearToken();
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 0, // Data is immediately stale, triggers refetch
      gcTime: 10 * 1000, // 10 seconds garbage collection
      refetchOnMount: true, // Refetch when component mounts
      refetchOnWindowFocus: false, // Optional: disable if you don't want this
    },
  },
});
